import styled from "styled-components";
// @ts-ignore
import buildColor from "@fdr/static-ui/ColorPalette";
// @ts-ignore
import fanduelShield from "@fdr/static-ui/images/fanduel-logo.png";
// @ts-ignore
import { fontNormal } from "@fdr/static-ui/Typography";

export const GeoComplyErrorWrapper = styled.section`
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("navy")};
  position: relative;

  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("${fanduelShield}");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 60vw 32px;
    opacity: 0.5;
  }
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 32px 22px;
  position: relative;
`;

export const Title = styled.h1`
  color: ${buildColor("white")};
  font-family: ${fontNormal};
  font-size: 22px;
  line-height: 22px;
  font-weight: 700;
  text-align: center;
  height: 60px;
`;

export const MapImage = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 14px;
  margin-bottom: 16px;
`;

export const ActionsContent = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding: 16px 16px 32px;
  background-color: ${buildColor("navy")};
  border-top: 2px solid ${buildColor("navy", "D1")};

  & > button:not(:only-child):not(:last-of-type) {
    margin-bottom: 8px;
  }
`;
